<template>
	<v-menu offset-y>
		<template v-slot:activator="{ on, attrs }">
			<span
				v-bind="attrs"
				v-on="on"
			>
				<country-flag
					country="ge"
				/>
			</span>
		</template>
		<v-list>
			<v-list-item
				v-for="(culture, index) in cultures"
				:key="index"
				@click="cultureSelection(culture.Name)"
			>
				<v-list-item-title>{{ culture.EnglishName }} {{ culture.NativeName }}</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
import cultureService from '@/service/culture-service';
import CountryFlag from 'vue-country-flag';

export default {
	components: {
		CountryFlag
	},
    data() {
        return {
			cultures: []
		};
	},
	created() {
		cultureService.cultures()
			.then(resp => this.cultures = resp);
	},
	methods: {
		cultureSelection(name) {
			this.$emit('select', name)
		}
	}
}
</script>